// Global Instructions Rule Applied!
import { supabase } from './supabase'

const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'

/**
 * Get authentication headers with JWT token
 */
export const getAuthHeaders = async () => {
  const {
    data: { session }
  } = await supabase.auth.getSession()
  if (!session?.access_token) {
    throw new Error('No authentication token available')
  }
  return {
    Authorization: `Bearer ${session.access_token}`,
    'Content-Type': 'application/json'
  }
}

/**
 * Generic API request function
 * @param {string} endpoint - API endpoint (with or without leading slash)
 * @param {Object} options - Fetch options
 * @returns {Promise<{ success?: boolean, data?: unknown, message?: string, error?: string }>} the backend envelope
 */
export const apiRequest = async (endpoint, options = {}) => {
  try {
    const headers = await getAuthHeaders()

    // Ensure endpoint starts with /
    const url = endpoint.startsWith('/') ? `${BASE_URL}${endpoint}` : `${BASE_URL}/${endpoint}`

    const response = await fetch(url, {
      method: 'GET',
      headers,
      ...options
    })

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status} ${response.statusText}`)
    }

    const result = await response.json()
    return result
  } catch (error) {
    console.error('API request error:', error)
    throw error
  }
}
